import { Component } from "react";
import Button from "./ui/Button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unexpected error" };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, message: "" });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-dvh grid place-items-center bg-surface p-6">
        <div className="max-w-md text-center surface-card p-8 sm:p-10">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-danger-subtle text-danger grid place-items-center mb-4">
            <span className="material-symbols-outlined text-[28px]">warning</span>
          </div>
          <h1 className="font-display text-2xl font-semibold text-ink mb-2">
            We hit a snag
          </h1>
          <p className="text-sm text-ink-muted mb-1">
            JustTrackIt ran into an unexpected error. Your data is safe.
          </p>
          {this.state.message && (
            <p className="text-xs font-mono text-ink-subtle mt-3 bg-surface-sunken rounded-md p-3 break-words text-left">
              {this.state.message}
            </p>
          )}
          <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-center mt-6">
            <Button variant="secondary" onClick={this.handleReset}>
              Try again
            </Button>
            <Button variant="primary" onClick={this.handleReload}>
              Reload app
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
